import { useAIChat } from './useAIChat';
import { AIChatContent } from './AIChatContent';

interface AIChatPanelProps {
  onChatStateChange?: (hasMessages: boolean, clearFn: () => void) => void;
}

/**
 * Thin wrapper that owns the useAIChat hook so chat state changes
 * don't trigger re-renders of the parent Flow component.
 */
export function AIChatPanel({ onChatStateChange }: AIChatPanelProps) {
  const chat = useAIChat();
  return <AIChatContent chat={chat} onChatStateChange={onChatStateChange} />;
}
